import type { SVGProps } from 'react';
export const IconPointsCdek = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17014_40720)">
      <path
        d="M18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5Z"
        fill="#1AB248"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.64343 20.2625H7.46768C5.63352 20.2625 6.96604 16.3958 8.51018 16.3958H10.3679C10.6657 16.3958 11.1909 16.4502 11.4496 15.7189L11.8493 14.583H9.30184C7.92232 14.583 6.84845 15.0654 6.07247 15.8745C4.73212 17.2594 4.2775 19.4222 4.59887 20.457C4.90456 21.4139 5.73542 22.0441 7.03657 22.0597L8.04772 22.0674H9.294L9.5997 21.1572C9.82701 20.5114 9.31753 20.2625 8.64343 20.2625ZM22.9562 18.6598L23.3402 17.4227H19.2408C18.5589 17.4227 18.2532 17.6095 18.1356 17.9985L17.7515 19.2355H21.851C22.5329 19.2355 22.8386 19.0488 22.9562 18.6598ZM17.1402 20.8382L16.7561 22.0752H20.8555C21.5296 22.0752 21.8431 21.8885 21.9607 21.4995L22.3448 20.2625H18.2454C17.5713 20.2625 17.2656 20.4492 17.1402 20.8382ZM23.9124 15.8278L24.2966 14.5908H20.1971C19.5152 14.5908 19.2095 14.7775 19.0919 15.1665L18.7078 16.4035H22.8073C23.4814 16.4035 23.787 16.2168 23.9124 15.8278ZM17.7202 16.0768C17.5477 14.9253 16.9285 14.5908 15.4236 14.5908H12.6802L11.0812 19.2355H12.0923C12.6958 19.2355 13.0015 19.2433 13.3229 18.3875L13.9892 16.3958H15.0081C15.8782 16.3958 15.6822 17.4772 15.2433 18.5275C14.8514 19.4533 14.1694 20.2703 13.3464 20.2703H11.6455C10.9636 20.2703 10.65 20.457 10.5246 20.846L10.1013 22.083H11.3476L12.5704 22.0752C13.6521 22.0674 14.5378 21.9896 15.5725 21.0638C16.6699 20.0757 17.9397 17.5394 17.7202 16.0768ZM31.5 14.583H29.125L26.891 16.9404C26.6323 17.2127 26.3658 17.485 26.1071 17.804H26.0836L27.1966 14.583H25.2607L22.6505 22.0752H24.5866L25.4173 19.7179L26.2795 18.9943L26.9616 21.1261C27.1731 21.7874 27.3927 22.0752 27.863 22.0752H29.3444L27.8237 17.8895L31.5 14.583Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_17014_40720">
        <rect
          width={36}
          height={36}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
